import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  "class": "mb-8 text-3xl font-bold"
};
var _hoisted_2 = /*#__PURE__*/_createTextVNode("Organizations");
var _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-indigo-400 font-medium"
}, "/", -1);
var _hoisted_4 = /*#__PURE__*/_createTextVNode(" This organization has been deleted. ");
var _hoisted_5 = {
  "class": "max-w-3xl bg-white rounded-md shadow overflow-hidden"
};
var _hoisted_6 = {
  "class": "flex flex-wrap -mb-8 -mr-6 p-8"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  value: null
}, null, -1);
var _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  value: "CA"
}, "Canada", -1);
var _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: "US"
}, "United States", -1);
var _hoisted_10 = {
  "class": "flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100"
};
var _hoisted_11 = /*#__PURE__*/_createTextVNode("Update Organization");
var _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", {
  "class": "mt-12 text-2xl font-bold"
}, "Contacts", -1);
var _hoisted_13 = {
  "class": "mt-6 bg-white rounded shadow overflow-x-auto"
};
var _hoisted_14 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", {
  "class": "text-left font-bold"
}, [/*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Name"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "City"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6",
  colspan: "2"
}, "Phone")], -1);
var _hoisted_16 = {
  "class": "border-t"
};
var _hoisted_17 = {
  "class": "border-t"
};
var _hoisted_18 = {
  "class": "border-t"
};
var _hoisted_19 = {
  "class": "w-px border-t"
};
var _hoisted_20 = {
  key: 0
};
var _hoisted_21 = /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4 border-t",
  colspan: "4"
}, "No contacts found.", -1);
var _hoisted_22 = [_hoisted_21];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_Link = _resolveComponent("Link");
  var _component_trashed_message = _resolveComponent("trashed-message");
  var _component_text_input = _resolveComponent("text-input");
  var _component_select_input = _resolveComponent("select-input");
  var _component_loading_button = _resolveComponent("loading-button");
  var _component_icon = _resolveComponent("icon");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: $data.form.name
  }, null, 8, ["title"]), _createElementVNode("h1", _hoisted_1, [_createVNode(_component_Link, {
    "class": "text-indigo-400 hover:text-indigo-600",
    href: "/organizations"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }), _hoisted_3, _createTextVNode(" " + _toDisplayString($data.form.name), 1)]), $props.organization.deleted_at ? (_openBlock(), _createBlock(_component_trashed_message, {
    key: 0,
    "class": "mb-6",
    onRestore: $options.restore
  }, {
    "default": _withCtx(function () {
      return [_hoisted_4];
    }),
    _: 1
  }, 8, ["onRestore"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("form", {
    onSubmit: _cache[9] || (_cache[9] = _withModifiers(function () {
      return $options.update && $options.update.apply($options, arguments);
    }, ["prevent"]))
  }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_text_input, {
    modelValue: $data.form.name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.name = $event;
    }),
    error: $data.form.errors.name,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Name"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.email,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.email = $event;
    }),
    error: $data.form.errors.email,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Email"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.phone,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.phone = $event;
    }),
    error: $data.form.errors.phone,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Phone"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.address,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.form.address = $event;
    }),
    error: $data.form.errors.address,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Address"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.city,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.form.city = $event;
    }),
    error: $data.form.errors.city,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "City"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.region,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.form.region = $event;
    }),
    error: $data.form.errors.region,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Province/State"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_select_input, {
    modelValue: $data.form.country,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.form.country = $event;
    }),
    error: $data.form.errors.country,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Country"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_7, _hoisted_8, _hoisted_9];
    }),
    _: 1
  }, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.postal_code,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $data.form.postal_code = $event;
    }),
    error: $data.form.errors.postal_code,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Postal code"
  }, null, 8, ["modelValue", "error"])]), _createElementVNode("div", _hoisted_10, [!$props.organization.deleted_at ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    "class": "text-red-600 hover:underline",
    tabindex: "-1",
    type: "button",
    onClick: _cache[8] || (_cache[8] = function () {
      return $options.destroy && $options.destroy.apply($options, arguments);
    })
  }, "Delete Organization")) : _createCommentVNode("", true), _createVNode(_component_loading_button, {
    loading: $data.form.processing,
    "class": "btn-indigo ml-auto",
    type: "submit"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_11];
    }),
    _: 1
  }, 8, ["loading"])])], 32)]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("table", _hoisted_14, [_hoisted_15, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.organization.contacts, function (contact) {
    return _openBlock(), _createElementBlock("tr", {
      key: contact.id,
      "class": "hover:bg-gray-100 focus-within:bg-gray-100"
    }, [_createElementVNode("td", _hoisted_16, [_createVNode(_component_Link, {
      "class": "flex items-center px-6 py-4 focus:text-indigo-500",
      href: "/campaigns/".concat(contact.id, "/edit")
    }, {
      "default": _withCtx(function () {
        return [_createTextVNode(_toDisplayString(contact.name) + " ", 1), contact.deleted_at ? (_openBlock(), _createBlock(_component_icon, {
          key: 0,
          name: "trash",
          "class": "flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"
        })) : _createCommentVNode("", true)];
      }),
      _: 2
    }, 1032, ["href"])]), _createElementVNode("td", _hoisted_17, [_createVNode(_component_Link, {
      "class": "flex items-center px-6 py-4",
      href: "/campaigns/".concat(contact.id, "/edit"),
      tabindex: "-1"
    }, {
      "default": _withCtx(function () {
        return [_createTextVNode(_toDisplayString(contact.city), 1)];
      }),
      _: 2
    }, 1032, ["href"])]), _createElementVNode("td", _hoisted_18, [_createVNode(_component_Link, {
      "class": "flex items-center px-6 py-4",
      href: "/campaigns/".concat(contact.id, "/edit"),
      tabindex: "-1"
    }, {
      "default": _withCtx(function () {
        return [_createTextVNode(_toDisplayString(contact.phone), 1)];
      }),
      _: 2
    }, 1032, ["href"])]), _createElementVNode("td", _hoisted_19, [_createVNode(_component_Link, {
      "class": "flex items-center px-4",
      href: "/campaigns/".concat(contact.id, "/edit"),
      tabindex: "-1"
    }, {
      "default": _withCtx(function () {
        return [_createVNode(_component_icon, {
          name: "cheveron-right",
          "class": "block w-6 h-6 fill-gray-400"
        })];
      }),
      _: 2
    }, 1032, ["href"])])]);
  }), 128)), $props.organization.contacts.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_22)) : _createCommentVNode("", true)])])]);
}